import {
    fencePaint,
    positionCircleFillPaint,
    positionCircleFillPaintInsideFence,
    positionCirclePaint,
    positionCirclePaintInsideFence
} from "@/styles/map.ts";
import { FillLayerSpecification, LineLayerSpecification } from "maplibre-gl";

export const sourceIdFences = "fences_sources";
export const layerIdFences = "fences_default_layer";

export const sourcePositionCircle = "position_circle";
export const layerPositionCircle = "position_circle_layer";
export const layerPositionCircleFill = "position_circle_fill_layer";

export enum PositionCircleStates {
    ACTIVITY_STARTED = "activity_started",
    INSIDE_FENCE = "inside_fence",
    INACCURATE_POSITION = "inaccurate_position"
}

export const mapLayerFences: LineLayerSpecification = {
    id: layerIdFences,
    type: "line",
    paint: fencePaint,
    source: sourceIdFences
};

export const mapLayerPositionCircle: LineLayerSpecification = {
    id: `${layerPositionCircle}_${PositionCircleStates.ACTIVITY_STARTED}`,
    type: "line",
    paint: positionCirclePaint,
    source: sourcePositionCircle,
    filter: ["==", "state", PositionCircleStates.ACTIVITY_STARTED]
};

export const mapLayerPositionCircleFill: FillLayerSpecification = {
    id: `${layerPositionCircleFill}_${PositionCircleStates.ACTIVITY_STARTED}`,
    type: "fill",
    paint: positionCircleFillPaint,
    source: sourcePositionCircle,
    filter: ["==", "state", PositionCircleStates.ACTIVITY_STARTED]
};

export const mapLayerPositionCircleInsideFence: LineLayerSpecification = {
    id: `${layerPositionCircle}_${PositionCircleStates.INSIDE_FENCE}`,
    type: "line",
    paint: positionCirclePaintInsideFence,
    source: sourcePositionCircle,
    filter: ["==", "state", PositionCircleStates.INSIDE_FENCE]
};

export const mapLayerPositionCircleFillInsideFence: FillLayerSpecification = {
    id: `${layerPositionCircleFill}_${PositionCircleStates.INSIDE_FENCE}`,
    type: "fill",
    paint: positionCircleFillPaintInsideFence,
    source: sourcePositionCircle,
    filter: ["==", "state", PositionCircleStates.INSIDE_FENCE]
};